import { render, staticRenderFns } from "./WarehouseStockTransfer.vue?vue&type=template&id=058e0916&"
import script from "./WarehouseStockTransfer.vue?vue&type=script&lang=js&"
export * from "./WarehouseStockTransfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports